export const commitHash = process.env.CURRENT_COMMIT_HASH;
export const frontVersion = process.env.FRONTEND_VERSION;
export const fullVersion = commitHash && frontVersion ? `${frontVersion}-${commitHash}` : frontVersion;
//# sourceMappingURL=front.js.map